<h1 mat-dialog-title class="notification-title">{{ heading }}</h1>
<div mat-dialog-content class="mat-dialog-content">
	<form [formGroup]="textForm">
		<div id="add-category" class="section">
			<p class="">{{ content }}</p>
			<mat-form-field appearance="outline" class="new-category" style="width: 100%; margin: 16px 0">
				<input matInput [placeholder]="'placeholder' | translate" formControlName="textControl" style="width: 100%" />
			</mat-form-field>
		</div>
	</form>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onOkClick()">{{ okButtonText }}</button>
	<button mat-flat-button color="primary" (click)="onCancelClick()" cdkFocusInitial>
		{{ cancelButtonText }}
	</button>
</div>
